import useCustonSignal from "src/use/customsignal";
const {
  getCustomSignalSMA,
  postCustomSignalSMA,
  getCustomSignalRSI,
  postCustomSignalRSI,
  getCustomSignalMACD,
  postCustomSignalMACD,
  getCustomSignalEMA,
  postCustomSignalEMA,
  getCustomSignalSuperTrend,
  postCustomSignalSuperTrend,
  getCustomSignalDI,
  postCustomSignalDI,
  getCustomSignalPSAR,
  postCustomSignalPSAR,
  customSignalProV2NewSave,
  customSignalProV2NewEdit
} = useCustonSignal();

export function onLoadCustonSignalSMA(context) {
  return new Promise((resolve, reject) => {
    getCustomSignalSMA()
      .then((res) => {
        context.commit("updategetCustomSignalSMA", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.log({ error });
        reject(error);
      });
  });
}

export function onPostCustomSignalSMA({ commit }, customsignal) {
  return new Promise((resolve, reject) => {
    postCustomSignalSMA(customsignal)
      .then((res) => {
        commit("updateCustomSignalSMA", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}
export function onLoadCustonSignalRSI({ commit }) {
  return new Promise((resolve, reject) => {
    getCustomSignalRSI()
      .then((res) => {
        commit("updategetCustomSignalRSI", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.log({ error });
        reject(error);
      });
  });
}

export function onPostCustomSignalRSI({ commit }, customsignal) {
  return new Promise((resolve, reject) => {
    postCustomSignalRSI(customsignal)
      .then((res) => {
        commit("updateCustomSignalRSI", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}
export function onLoadCustonSignalMACD({ commit }) {
  return new Promise((resolve, reject) => {
    getCustomSignalMACD()
      .then((res) => {
        commit("updategetCustomSignalMACD", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.log({ error });
        reject(error);
      });
  });
}

export function onPostCustomSignalMACD({ commit }, customsignal) {
  return new Promise((resolve, reject) => {
    postCustomSignalMACD(customsignal)
      .then((res) => {
        commit("updateCustomSignalMACD", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}
export function onLoadCustonSignalEMA({ commit }) {
  return new Promise((resolve, reject) => {
    getCustomSignalEMA()
      .then((res) => {
        commit("updategetCustomSignalEMA", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.log({ error });
        reject(error);
      });
  });
}

export function onPostCustomSignalEMA({ commit }, customsignal) {
  return new Promise((resolve, reject) => {
    postCustomSignalEMA(customsignal)
      .then((res) => {
        commit("updateCustomSignalEMA", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export function onLoadCustonSignalSuperTrend({ commit }) {
  return new Promise((resolve, reject) => {
    getCustomSignalSuperTrend()
      .then((res) => {
        commit("updategetCustomSignalSuperTrend", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.log({ error });
        reject(error);
      });
  });
}

export function onPostCustomSignalSuperTrend({ commit }, customsignal) {
  return new Promise((resolve, reject) => {
    postCustomSignalSuperTrend(customsignal)
      .then((res) => {
        commit("updateCustomSignalSuperTrend", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export function onLoadCustonSignalDI({ commit }) {
  return new Promise((resolve, reject) => {
    getCustomSignalDI()
      .then((res) => {
        commit("updategetCustomSignalDI", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.log({ error });
        reject(error);
      });
  });
}

export function onPostCustomSignalDI({ commit }, customsignal) {
  return new Promise((resolve, reject) => {
    postCustomSignalDI(customsignal)
      .then((res) => {
        commit("updateCustomSignalDI", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}
export function onLoadCustonSignalPSAR({ commit }) {
  return new Promise((resolve, reject) => {
    getCustomSignalPSAR()
      .then((res) => {
        commit("updategetCustomSignalPSAR", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.log({ error });
        reject(error);
      });
  });
}

export function onPostCustomSignalPSAR({ commit }, customsignal) {
  return new Promise((resolve, reject) => {
    postCustomSignalPSAR(customsignal)
      .then((res) => {
        commit("updateCustomSignalPSAR", res.data);
        resolve(res.data);
      })
      .catch((error) => {
        console.log(error);
        reject(error);
      });
  });
}

export function onPostcustomSignalProV2NewSave({ commit }, payload) {
  return new Promise((resolve, reject) => {
    customSignalProV2NewSave(payload).then(()=>{
      commit('updateSaveModelSubmitedCount')
      resolve()
    }).catch((error)=>{
      reject(error)
    })
  });
}
export function onPatchCustomSignalProV2New({ commit }, payload) {
  return new Promise((resolve, reject) => {
    customSignalProV2NewEdit(payload).then(()=>{
      commit('updateSaveModelSubmitedCount')
      resolve()
    }).catch((error)=>{
      reject(error)
    })
  });
}
